import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseAuth, firebaseDatabase } from '@/services/firebase'
import moment from 'moment'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    videos: [],
  },
  mutations: {
    setVideos(state, payload) {
      state.videos = payload
    },
    insertVideo(state, payload) {
      state.videos.push(payload)
    },
  },
  actions: {
    async getVideos(context) {
      const videosPayload = []
      firebaseDatabase.collection('videos')
        .where('userID', '==', firebaseAuth.currentUser.uid)
        .orderBy('publishDue', 'desc')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const data = {
              videoID: doc.id,
              pillarName: doc.data().pillarName,
              keywordName: doc.data().keywordName,
              thumbnail: doc.data().thumbnail,
              title: doc.data().title,
              daysFromPublish: Math.round(moment.duration(moment().diff(doc.data().publishDue)).asDays()),
              channelName: doc.data().channelName,
              shortDescription: doc.data().shortDescription,
              titleDue: doc.data().titleDue,
              titleComplete: doc.data().titleComplete,
              thumbnailDue: doc.data().thumbnailDue,
              thumbnailComplete: doc.data().thumbnailComplete,
              script: doc.data().script,
              scriptDue: doc.data().scriptDue,
              scriptComplete: doc.data().scriptComplete,
              filmDue: doc.data().filmDue,
              filmComplete: doc.data().filmComplete,
              editDue: doc.data().editDue,
              editComplete: doc.data().editComplete,
              tags: doc.data().tags,
              tagsDue: doc.data().tagsDue,
              tagsComplete: doc.data().tagsComplete,
              description: doc.data().description,
              descriptionDue: doc.data().descriptionDue,
              descriptionComplete: doc.data().descriptionComplete,
              uploadDue: doc.data().uploadDue,
              uploadComplete: doc.data().uploadComplete,
              promoteDue: doc.data().promoteDue,
              promoteComplete: doc.data().promoteComplete,
              publishDue: doc.data().publishDue,
              publishComplete: doc.data().publishComplete,
              engageDue: doc.data().engageDue,
              engageComplete: doc.data().engageComplete,
            }
            videosPayload.push(data)
          })
        })

      context.commit('setVideos', videosPayload)
    },
  },
  getters: {
    state: state => state,
  },
}
